import { render, staticRenderFns } from "./CategoryFaq.vue?vue&type=template&id=df32d5dc&scoped=true&"
import script from "./CategoryFaq.vue?vue&type=script&lang=js&"
export * from "./CategoryFaq.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFaq.vue?vue&type=style&index=0&id=df32d5dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df32d5dc",
  null
  
)

export default component.exports